// assets/arrow-override.js
(function () {
  if (window.__ArrowSwapInit) return; window.__ArrowSwapInit = true;

  // Optional: disable while editing in Theme Editor (uncomment if you prefer)
  // if (window.Shopify && Shopify.designMode) return;

  function onReady(fn){
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn, { once: true });
    } else { fn(); }
  }

  onReady(function(){
    const SKIP = new Set(['SCRIPT','STYLE','NOSCRIPT','TEXTAREA','CODE','KBD','PRE','SVG']);
    const ARROWS = ['\u2192','\u27F6','\u279E','\u2794']; // → ⟶ ➞ ➔

    function shouldSkip(node){
      let p = node.parentElement;
      while (p){
        if (SKIP.has(p.tagName)) return true;
        if (p.classList && p.classList.contains('u-arrow-ic')) return true;
        p = p.parentElement;
      }
      return false;
    }

    function swap(root){
      if (!root) return;
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
        acceptNode(node){
          if (!node.nodeValue) return NodeFilter.FILTER_REJECT;
          if (shouldSkip(node)) return NodeFilter.FILTER_REJECT;
          for (const a of ARROWS) if (node.nodeValue.indexOf(a) !== -1) return NodeFilter.FILTER_ACCEPT;
          return NodeFilter.FILTER_REJECT;
        }
      });
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);

      nodes.forEach(node=>{
        let text = node.nodeValue;
        ARROWS.forEach(a => text = text.split(a).join('§ARROW§'));
        const parts = text.split('§ARROW§');

        const frag = document.createDocumentFragment();
        parts.forEach((part, i) => {
          if (part) frag.appendChild(document.createTextNode(part));
          if (i < parts.length - 1) {
            const iEl = document.createElement('i');
            iEl.className = 'u-arrow-ic';
            iEl.setAttribute('aria-hidden','true');
            frag.appendChild(iEl);
          }
        });
        if (node.parentNode) node.parentNode.replaceChild(frag, node);
      });
    }

    // initial + dynamic
    swap(document.body);
    new MutationObserver(muts=>{
      for (const m of muts){
        if (m.addedNodes) m.addedNodes.forEach(n=>{ if (n.nodeType===1) swap(n); });
        if (m.type==='characterData' && m.target && m.target.nodeType===3) swap(m.target.parentNode);
      }
    }).observe(document.body,{childList:true,subtree:true,characterData:true});
  });
})();
